import { getSubdomain } from "./subdomian";

export const getApiBaseUrlTenant = () => {
  const subdomain = getSubdomain();
  const protocol = window.location.protocol; // http or https
  return `${protocol}//${subdomain}.${process.env.REACT_APP_MICRO_API_URL}/tenant_api`;
};
